var ColorUtils = /** @class */ (function () {
    function ColorUtils() {
    }
    ColorUtils.getTints = function (color) {
        var hsl = this.getHexToHSL(color);
        return hsl['l'] < .60 ? "#FFFFFF" : "#000000";
    };
    ColorUtils.getDecToHex = function (color, prefix) {
        if (prefix === void 0) { prefix = "#"; }
        if (typeof color === "string")
            color = parseInt(color);
        color = color.toString(16);
        for (var i = color.length; i < 6; i++) {
            color = "0" + color;
        }
        return prefix + color;
    };
    ColorUtils.getHexToHSL = function (color) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        var r = parseInt(result[1], 16);
        var g = parseInt(result[2], 16);
        var b = parseInt(result[3], 16);
        r /= 255, g /= 255, b /= 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) {
            h = s = 0; // achromatic
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        var HSL = {};
        HSL['h'] = h;
        HSL['s'] = s;
        HSL['l'] = l;
        return HSL;
    };
    return ColorUtils;
}());
export { ColorUtils };
//# sourceMappingURL=color-utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-utils/color-utils.js
// module id = 412
// module chunks = 14